import React from 'react';
import { hooks } from '@lifesize/clients.sdk';
import { connect } from 'react-redux';
import CallDetails from 'components/InCall/CallDetails';
import { contactSelectors, currentUserSelectors, featureSelectors } from '@lifesize/nucleus';
import _get from 'lodash/get';
import { closeInCallDrawer } from 'actions/InCall/InCallDrawer';
import { CALL_DETAILS_DRAWER } from 'constants/InCall/InCallDrawer';
import { FLAG_PRESENTATION_RESTRICTION, FLAG_WAITING_ROOM } from 'constants/FeatureFlags';

const mapStateToProps = (state, ownProps) => {
  const currentUser = currentUserSelectors.myInfo(state);
  const currentUserUuid = currentUserSelectors.getUserUUID(state);
  const conferenceUuid = _get(ownProps, 'conference.uuid');
  const contact = conferenceUuid
    ? contactSelectors.getContactByUuidGenerator(state)(conferenceUuid)
    : contactSelectors.getContactByDialStringGenerator(state)(_get(ownProps, 'call.dialString'));
  const visibleComponent = _get(state, 'app.inCallDrawer.subComponentType');
  const isVisible = visibleComponent === CALL_DETAILS_DRAWER;

  const presentationRestrictionEnabled = featureSelectors.getFeatureFlag(state)(FLAG_PRESENTATION_RESTRICTION);
  const waitingRoomFeatureEnabled = !!featureSelectors.getFeatureFlag(state)(FLAG_WAITING_ROOM);
  const callContact = contact || currentUser;
  // Create an array of participant names (as strings)
  // For escalated ad-hoc calls, list the names of each of the other participants (exclude self),
  // otherwise list the display name of the contact
  const callDisplayName =
    ownProps.conference?.type === 'ADHOC' && ownProps.conference?.state === 'escalated'
      ? ownProps.participants
          .filter((participant) => participant.uuid !== currentUserUuid)
          .map((participant) => participant.name)
          .sort()
      : [ownProps.conferenceDisplayName || callContact.displayName || ownProps.call?.dialString || ''];

  return {
    callDisplayName,
    contact: callContact,
    isVisible,
    presentationRestrictionEnabled,
    waitingRoomFeatureEnabled
  };
};

const mapDispatchToProps = (dispatch) => ({
  closeInCallDrawer
});

const ConnectedComponent = connect(mapStateToProps, mapDispatchToProps)(CallDetails);

const FunctionalWrapper = (props) => {
  const isModerator = hooks.useIsCurrentUserModerator();
  const call = hooks.useCallState();
  const conference = hooks.useConferenceInfo();
  const conferenceDisplayName = hooks.useConferenceDisplayName();
  const participants = hooks.useParticipants();

  return (
    <ConnectedComponent
      {...props}
      call={call}
      conference={conference}
      conferenceDisplayName={conferenceDisplayName}
      isModerator={isModerator}
      participants={participants}
    />
  );
};
export { ConnectedComponent as InCallCallDetailsContainer };
export default FunctionalWrapper;
